var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import ReactDOM from "react-dom";
import { IconButton, Tooltip } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { useConfirmationDialog } from "frontend/src/ui/dialog";
import red from "@material-ui/core/colors/red";
export var DeleteButtonWithModal = React.forwardRef(function (_a, ref) {
    var onDelete = _a.onDelete, message = _a.message, props = __rest(_a, ["onDelete", "message"]);
    var _b = useConfirmationDialog({
        open: false,
        onConfirm: onDelete,
        message: message,
    }), open = _b.open, Dialog = _b.Dialog;
    var spread = __assign(__assign({}, props), { ref: ref });
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, __assign({ onClick: open, size: "small" }, spread),
            React.createElement(Tooltip, { title: "Удалить" },
                React.createElement(Delete, { htmlColor: red[700] }))),
        ReactDOM.createPortal(React.createElement(Dialog, null), document.body)));
});
